import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import {Title} from 'components/DSYS/Title';
import type {ReactNode} from 'react';

export const OwnershipDetailLayout = ({
  title,
  description,
  titleAccessory,
  headerContent,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  titleAccessory?: ReactNode;
  headerContent?: ReactNode;
  children?: ReactNode;
}) => (
  <Stack gap="24">
    <Stack gap="8">
      <Title withAccessoryStart={titleAccessory}>{title}</Title>
      {headerContent}
      {description ? (
        <Text variant="paragraph" size="medium" color="subtle" tagName="p">
          {description}
        </Text>
      ) : null}
    </Stack>
    {children}
  </Stack>
);
